import React from "react"
import { CurrencyFormat, ListFormat } from "../../../Formatters";

export default function AboutData(minAge, maxAge, minCoverageAmount, maxCoverageAmount, termLengths) {
    return {
        title: "About Loan Protection Life Insurance",
        content:
            "Loan protection life insurance, also known as Decreasing term insurance, is a type of life insurance policy where the death benefit gradually decreases over time, typically in sync with a specific financial obligation like a mortgage or a loan. The premiums remain constant, but the coverage amount decreases as the policy matures. This insurance is designed to provide financial protection for a specific debt or expense, ensuring that if the insured person passes away, the policy can help pay off the outstanding balance, making it an appropriate choice for individuals looking to cover a diminishing financial liability.",
        productData: [
           {
                title: "Who can apply?",
                text: `U.S. citizens or permanent residents ages ${minAge} - ${maxAge}`,
            },
            {
                title: "Coverage Lengths",
                text:  <span><ListFormat numbers={termLengths.map(n => n.value)} /> years - designed to match your loan schedule</span>,
            },
            {
                title: "Coverage Amount",
                text: <span><CurrencyFormat number={minCoverageAmount} whole /> - <CurrencyFormat number={maxCoverageAmount} whole /></span>,
            },
        ]
    }
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/LoanProtection/AboutData.js